import type { RoadKit } from "../kit/types";

/**
 * Sunstone road (300 gems; contract tools/art/skins/README.md §Roads). Warm sandstone basketweave pavers (the ground
 * shader's paving, render/groundPave.ts) between sandstone kerbs with a gold strip along the road's edge, dressed from
 * `art/hq/skins/sunstone/kit.glb` (tools/art/skins/roads.py): a sandstone roundel with a glowing sun glyph every third
 * cell, sandstone obelisks on the verge with a gold sun wheel turning over each, brass lamps with a flickering flame,
 * and gold motes. The glow of the kerbs' gold and the suns rolls down the road from the portal to the fortress, the way
 * the enemies walk (`travel`, by cells along the road: kit/roadDecor.ts).
 */
/** The wave down the road: radians a cell, and its rate (≈ 2 cells a second). */
const SUN_WAVE = { travel: 0.9, hz: 0.22 } as const;

export const SUNSTONE: RoadKit = {
  id: "road.sunstone",
  tint: [1.18, 0.98, 0.68],
  asset: "skins/sunstone/kit",
  surface: {
    pattern: "basket", scale: 1.5, jointWidth: 0.05, grain: 0.55, bevel: 0.7,
    stone: [0.5, 0.33, 0.16], stone2: [0.42, 0.25, 0.11], joint: [0.16, 0.1, 0.05],
  },
  // the kerbs first: the instance cap fills piece by piece, so a very long road thins its lamps, never its edges
  pieces: [
    { piece: "kerb", every: 1, place: "centre", on: "straight", motion: { glow: 0.7, ...SUN_WAVE } },
    { piece: "kerbturn", every: 1, place: "centre", on: "turn", motion: { glow: 0.7, ...SUN_WAVE } },
    { piece: "sun", every: 3, place: "centre", on: "straight", motion: { glow: 0.85, ...SUN_WAVE } },
    { piece: "obelisk", every: 4, phase: 1, place: "verge", side: 0.6, on: "straight" },
    { piece: "sunwheel", every: 4, phase: 1, place: "verge", side: 0.6, on: "straight", lift: 0.76, motion: { roll: 0.6, glow: 0.4, hz: 0.35 } },
    { piece: "lamp", every: 4, phase: 3, place: "verge", side: 0.58, on: "straight", motion: { glow: 0.35, hz: 1.7 } },
    { piece: "mote", every: 4, phase: 0, place: "verge", side: 0.52, detail: true, motion: { twinkle: 0.3 } },
  ],
};
